import { ProductInfo } from 'src/types/common';
import defaultProductImage from 'src/assets/default_product.svg?url';

export const getProductMainImage = (product: ProductInfo): string => {
  return (
    product?.main_photo ||
    product?.images?.find((img) => img.is_main)?.image ||
    product?.images?.[0]?.image ||
    defaultProductImage
  );
};
